interface ResponseEnvelope {
  readonly requestId: string;
  readonly status: string;
}

interface ResponseSuccessData<T> {
  readonly result: T;
}

export interface ResponseSuccess<T> extends ResponseEnvelope {
  readonly data: ResponseSuccessData<T>;
}

export enum ProductCategory {
  Analytics = 'ANALYTICS',
  Encoding = 'ENCODING',
  Player = 'PLAYER'
}

export enum SalesDemoCategory {
  ADDITIONAL_DEMOS = 'ADDITIONAL_DEMOS',
  MONETIZATION = 'MONETIZATION',
  EMBEDDED = 'EMBEDDED',
  INNOVATION = 'INNOVATION',
  EASE_OF_USE = 'EASE_OF_USE',
  PARTNERS = 'PARTNERS',
  HIGHER_QUALITY = 'HIGHER_QUALITY'
}

export enum SalesDemoTag {
  BETA = 'BETA',
  PATENT_PENDING = 'PATENT_PENDING',
  PROTOTYPE = 'PROTOTYPE'
}

export interface SalesDemo {
  readonly id: string;
  readonly category: SalesDemoCategory;
  readonly description: string;
  readonly name: string;
  readonly path: string;
  readonly products: ReadonlyArray<ProductCategory>;
  readonly tags: ReadonlyArray<SalesDemoTag>;
}

export interface WrapperAppSalesDemos {
  readonly baseUrl: string;
  readonly demos: ReadonlyArray<SalesDemo>;
}
